import { ArrowDownIcon, ArrowUpIcon, XIcon } from 'lucide-react-native';
import { useState } from 'react';
import { YStack } from 'tamagui';

import { SelectTile } from '../../components/select/SelectTile';
import { BodySmallRegular } from '../../components/text/Typography';

export const SelectTiles = () => {
    const [selectedTile, setSelectedTile] = useState(0);
    return (
        <YStack gap={16}>
            <BodySmallRegular>
                This is another format we have for a list of selectable options.
                These are typically used as buttons to navigate to another
                screen, but there is a selected state as well.
            </BodySmallRegular>
            <YStack gap={16} maxWidth={450}>
                <SelectTile
                    title="By default, the icon is on the right"
                    icon={ArrowUpIcon}
                    isSelected={selectedTile === 0}
                    onPress={() => {
                        setSelectedTile(0);
                    }}
                />
                <SelectTile
                    title="You can include a description"
                    description="Which looks like this"
                    icon={ArrowDownIcon}
                    isSelected={selectedTile === 1}
                    onPress={() => {
                        setSelectedTile(1);
                    }}
                />
                <SelectTile
                    title="If the title is really long, it will wrap onto a second line"
                    icon={ArrowUpIcon}
                    iconLeft
                    isSelected={selectedTile === 2}
                    onPress={() => {
                        setSelectedTile(2);
                    }}
                />
                <SelectTile
                    title="I wonder if it will work fine if we have a really long title"
                    description="And a long description that will wrap onto multiple lines"
                    icon={ArrowDownIcon}
                    iconLeft
                    isSelected={selectedTile === 3}
                    onPress={() => {
                        setSelectedTile(3);
                    }}
                />
                <SelectTile
                    title="This one is disabled"
                    icon={XIcon}
                    iconLeft
                    isSelected={selectedTile === 4}
                    onPress={() => {
                        setSelectedTile(4);
                    }}
                    disabled
                />
            </YStack>
        </YStack>
    );
};
